import { useCallback } from 'react';
import { getFirebase } from 'firestorter';

// 7 Days Silence Duration in milliseconds
const SILENCE_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

const useSilenceToggle = (userDoc) => {
  const isSilenced = userDoc?.disengagementBroadcastSilencedUntil > new Date();

  const handleSilenceToggle = useCallback(() => {
    if (!userDoc) return;
    // Map-scoped write — the getter and every server reader are on the coach
    // entry, so a root write here would be an invisible no-op.
    if (isSilenced) {
      userDoc.updateDisengagementBroadcastSilencedUntil(getFirebase().firestore.FieldValue.delete());
    } else {
      userDoc.updateDisengagementBroadcastSilencedUntil(new Date(Date.now() + SILENCE_DURATION_MS));
    }
  }, [userDoc, isSilenced]);

  return { isSilenced, handleSilenceToggle };
};

export default useSilenceToggle;
